import activeBranchesReducer from './activeBranchesReducer';
import defectsReducer from './defectsReducer';
import repositoriesReducer from './repositoriesReducer';
import repositoryReducer from './repositoryReducer';
import userReducer from './userReducer';
export default {
    activeBranches: activeBranchesReducer,
    defects: defectsReducer,
    repositories: repositoriesReducer,
    repository: repositoryReducer,
    user: userReducer,
};
